import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const inputFileGroupFn = /* @__PURE__ */ createRecipe('input-file-group', {}, [])

const inputFileGroupVariantMap = {}

const inputFileGroupVariantKeys = Object.keys(inputFileGroupVariantMap)

export const inputFileGroup = /* @__PURE__ */ Object.assign(memo(inputFileGroupFn.recipeFn), {
  __recipe__: true,
  __name__: 'inputFileGroup',
  __getCompoundVariantCss__: inputFileGroupFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: inputFileGroupVariantKeys,
  variantMap: inputFileGroupVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, inputFileGroupVariantKeys)
  },
  getVariantProps: inputFileGroupFn.getVariantProps,
})